export default [
  {
    path: '/parametros',
    name: 'parametros',
    component: () => import('@/views/sistema/parametros/list/Index.vue'),
    meta: {
      pageTitle: 'Parâmetros',
      adminDkpOnly: true,
    },
  },
];
